import { Button, Checkbox, Dropdown, Menu } from 'antd-v4'
import { DownOutlined } from '@ant-design/icons'
import * as React from 'react'

interface IOption {
  id: number
  name: string
}

interface IFilterDropdownV2 {
  label: string
  options: IOption[]
  selectedOptionIds: number[]
  onSelect: (optionId: number) => void
  selectAllOptions: () => void
  unselectAllOptions: () => void
}

export const FilterDropdownV2 = ({
  label,
  options,
  selectedOptionIds,
  onSelect,
  selectAllOptions,
  unselectAllOptions,
}: IFilterDropdownV2) => {
  const AllAndNoneOptions = () => (
    <div className='text-right'>
      <Button className='mr-2 p-0' type='link' onClick={selectAllOptions}>
        All
      </Button>
      <Button className='p-0' type='link' onClick={unselectAllOptions}>
        None
      </Button>
    </div>
  )

  const OptionCheckbox = ({ id, name }: IOption) => {
    return (
      <Checkbox
        checked={selectedOptionIds.includes(id)}
        className='w-100 pb-2'
        onClick={() => {
          onSelect(id)
        }}
      >
        {name}
      </Checkbox>
    )
  }

  const dropdownOverlay = (
    <Menu className='p-3'>
      <AllAndNoneOptions />
      {options.map((option) => {
        return (
          <Menu.Item key={option.id} disabled style={{ padding: 0 }}>
            <OptionCheckbox id={option.id} name={option.name} />
          </Menu.Item>
        )
      })}
    </Menu>
  )

  const selectedOptionCount =
    options.length === selectedOptionIds.length ? 'all' : selectedOptionIds.length

  return (
    <Dropdown
      className='mr-2'
      trigger={['click']}
      overlay={dropdownOverlay}
      disabled={options.length <= 1}
    >
      <Button
        style={{
          borderRadius: '4px',
          borderWidth: '1px',
          width: 150,
        }}
      >
        {`${label} (${selectedOptionCount})`}
        <DownOutlined />
      </Button>
    </Dropdown>
  )
}
